// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/property.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Address } from "./address";
import { Date } from "./date";
/**
 * Real estate the household owns, with or without a mortgage (Mortgage.property_uuid points here).
 *
 * @generated from protobuf message core.v1.Property
 */
export interface Property {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: core.v1.PropertyKind kind = 3;
     */
    kind: PropertyKind;
    /**
     * @generated from protobuf field: optional double current_value = 4;
     */
    currentValue?: number; // as of its value source date
    /**
     * @generated from protobuf field: optional double purchase_price = 5;
     */
    purchasePrice?: number;
    /**
     * @generated from protobuf field: core.v1.Date purchase_date = 6;
     */
    purchaseDate?: Date;
    /**
     * @generated from protobuf field: optional double annual_property_tax = 7;
     */
    annualPropertyTax?: number;
    /**
     * @generated from protobuf field: optional double annual_insurance = 8;
     */
    annualInsurance?: number;
    /**
     * @generated from protobuf field: core.v1.Address address = 9;
     */
    address?: Address;
    /**
     * @generated from protobuf field: repeated string owner_uuids = 10;
     */
    ownerUuids: string[]; // Person uuids; empty = all adults
}
/**
 * @generated from protobuf enum core.v1.PropertyKind
 */
export enum PropertyKind {
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_PRINCIPAL_RESIDENCE = 1;
     */
    PRINCIPAL_RESIDENCE = 1,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_RENTAL = 2;
     */
    RENTAL = 2,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_COTTAGE = 3;
     */
    COTTAGE = 3,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_SECONDARY_HOME = 4;
     */
    SECONDARY_HOME = 4,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_INVESTMENT = 5;
     */
    INVESTMENT = 5,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_LAND = 6;
     */
    LAND = 6,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_FAMILY_MEMBER_HOME = 7;
     */
    FAMILY_MEMBER_HOME = 7,
    /**
     * @generated from protobuf enum value: PROPERTY_KIND_OTHER = 8;
     */
    OTHER = 8
}
// @generated message type with reflection information, may provide speed optimized methods
class Property$Type extends MessageType<Property> {
    constructor() {
        super("core.v1.Property", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "kind", kind: "enum", T: () => ["core.v1.PropertyKind", PropertyKind, "PROPERTY_KIND_"] },
            { no: 4, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "purchase_price", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "purchase_date", kind: "message", T: () => Date },
            { no: 7, name: "annual_property_tax", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "annual_insurance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "address", kind: "message", T: () => Address },
            { no: 10, name: "owner_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Property
 */
export const Property = new Property$Type();
